import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import styled from 'styled-components';

export const SkipLink = ({ to, text }) => {
    return to && text ? <StyledLink to={to}>{text}</StyledLink> : null;
};

SkipLink.propTypes = { to: PropTypes.string, text: PropTypes.string };

export const StyledLink = styled(Link)`
    background: #fff;
    padding: 0.5rem;
    position: fixed;
    z-index: -1;
    left: -3000rem;
    top: -3000rem;

    &:focus {
        z-index: 999;
        left: 0;
        top: 0;
    }
`;

export default connect(({ skipLink }) => skipLink)(SkipLink);



// WEBPACK FOOTER //
// ./src/components/skip_link.jsx